import React, { memo, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { colors, fonts, frames } from "../../../Styles";
import { SecondaryPopover } from "../..";
import { useAttentionLog } from "../../../Services";
import { StationInfo } from "../../../Services/Agrisys_GqlDataCaller/WalkThroughDataCalls/getEsfStructureCall";
import { currentEsfViewTypes, useEsfContext } from "../_EsfWalkThrough/EsfContext";
import { styled } from "styletron-react";

interface PenBasic_Props {
  station: StationInfo;
  gridArea: string;
  focus_view?: boolean;
  popoverContent?: JSX.Element;
  overrides?: {
    primaryColor?: colors;
    textColor?: colors;
    width?: string;
    border?: string;
    attention?: number
  }
}

export default function ESF_STATION({ station, gridArea, focus_view, popoverContent, overrides }: PenBasic_Props) {
  const { t } = useTranslation();
  const { state: { selectedStations, currentStationViewType, connection, domain, system }, dispatch } = useEsfContext();
  
  // Styles
  const _primaryColor = overrides && overrides.primaryColor ? overrides.primaryColor : colors.greyLightSecondary
  const _textColor = overrides && overrides.textColor ? overrides.textColor : colors.greyDarkPrimary
  const _width = overrides && overrides.width ? overrides.width : "80px"
  const _border = overrides && overrides.border ? overrides.border : "none"
    
  // #region | Attentions
  // const { data: attentionLogState, call: getAttentionLogs } = useAttentionLog(connection);

  // useEffect(() => {
  //   if (system.system_id) {
  //     getAttentionLogs({ ids: [system.system_id] })
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [])

  // const logData = useMemo(() => {
  //   if (domain in attentionLogState && attentionLogState[domain] && typeof attentionLogState[domain] === "object" && "data" in attentionLogState[domain] && attentionLogState[domain].data && system.system_id) {
  //     return attentionLogState[domain].data.filter((log) => log.fk_systems === system.system_id && log.dismissed !== true);
  //   }
  //   return []
  // }, [attentionLogState, domain, system.system_id])

  // Til senere: Find ud af om min section (fk_locations) er på en af terminalerne for stationen for at finde ud af om den specifikke station har en attention.
  // const hasAttention = useMemo(() => overrides&&overrides.attention ? true : logData.some(data => data.fk_locations === pen.location_id), [logData, overrides, pen.location_id]);
  // const penAttentionLevel = useMemo(() => overrides&&overrides.attention ? overrides.attention : logData.find(data => data.fk_locations === pen.location_id)?.level, [logData, overrides, pen.location_id])
  // const attentionOverlay = <Attention attentionLevel={penAttentionLevel} hasAttention={hasAttention} fromOverrides={overrides&&overrides.attention !== undefined ? true : false} />
  // #endregion
  
  // #region | SystemControle / On station click
  const handleClick = () => {
    const alreadySelected = selectedStations?.some((p) => p === station);

    let newSelectedList;

    if (alreadySelected) {
      newSelectedList = selectedStations?.filter((p) => p !== station);
    } else {
      newSelectedList = [...(selectedStations ?? []), station];
    }

    dispatch({ selectedStations: newSelectedList });
  }
  // #endregion

  const Pen = () => {
    switch (currentStationViewType) {
      case currentEsfViewTypes.systemControle:
        return (
          <frames.LfPen onClick={handleClick} $gridArea={gridArea} $selectable $isSelected={selectedStations && selectedStations.some(p => p === station)} $primaryColor={_primaryColor} $textColor={_textColor} $width={_width} $border={_border} style={{ ...fonts.paragraph, ...(focus_view ? fonts.fontSize3 : fonts.fontSize4), cursor: "pointer" }} >
            { popoverContent ?
              <SecondaryPopover
                // content={<div style={{}}>{station?.name} {overrides&&overrides.attention ? attentionOverlay : undefined}</div>} // Når attention bliver en ting
                content={<div style={{}}>{station?.name}</div>}
                popoverHeader=""
                popoverContent={<>{popoverContent}</>}
                overrides={{ primaryColor: colors.greyDarkPrimary }}
              />
            : station?.name }      
          </frames.LfPen>
        );
      case currentEsfViewTypes.attention:
        return (
          <frames.LfPen $primaryColor={_primaryColor} $textColor={_textColor} $gridArea={gridArea} $width={_width} $border={_border} >
            {/* { hasAttention ? attentionOverlay : undefined } Når attention bliver en ting */}
          </frames.LfPen>
        );
      case currentEsfViewTypes.basic:
      default:
        return (
          <Station content={station.name}/>
        )
    }
  }

  return Pen();
}

// #region | Attention Pen
const Attention = memo(({ attentionLevel, hasAttention, fromOverrides }: { attentionLevel?: number, hasAttention: boolean, fromOverrides: boolean }) => {
  const [animate, setAnimate] = useState<boolean>(false);
  const _width = animate ? "10px" : "0px"

  const resolveColor = () => {
    if (fromOverrides) {
      return attentionLevel === 0 ? colors.systemRed : colors.graphBlueTwo;
    } else {
      return attentionLevel === 0 ? colors.systemRed : colors.systemYellow;
    }
  };
  
  useEffect(() => {
    setAnimate(true);
  }, []);

  if (!hasAttention) return null;
  return (
    <div style={{
      top: "0",
      left: "0",
      position: "absolute",
      zIndex: "2",
      height: "100%",
      width: _width,
      backgroundColor: resolveColor(),
      transition: "width 0.5s ease"
    }} />
  ) 
})
// #endregion

// #region | Station
const Station = memo(({ content }: { content: string | JSX.Element}) => {
  const StationPathStyle = styled("path", {
    stroke: "none",
    fill: colors.greyLightPrimary,
  })

  const ArrowPathStyle = styled("path", {
    stroke: "none",
    fill: colors.whitePrimary
  })
    
  return ( <div style={{position: "relative"}}>
    <div style={{ width: "155px", height: "36px" }}>
      <svg viewBox="0 0 158 37" >
        <StationPathStyle d="M158 34V8C158 6.34315 156.657 5 155 5H25.2774C24.7675 5 24.2661 4.87007 23.8204 4.62247L18.239 1.52165C16.7459 0.692175 14.8626 1.27481 14.0988 2.80248L1.26917 28.4617C0.55712 29.8858 1.08162 31.6181 2.46404 32.408L9.80828 36.6047C10.2616 36.8638 10.7746 37 11.2967 37H155C156.657 37 158 35.6569 158 34Z" />
        <ArrowPathStyle d="M15.1865 10.1073L20.8455 19.1073L22.2834 16.2465L32.0242 21.1425L34.0883 17.0357L24.3476 12.1398L25.7855 9.27897L15.1865 10.1073Z" />
        <ArrowPathStyle d="M9.78066 20.8207L15.4396 29.8207L16.8775 26.9599L26.6183 31.8559L28.6825 27.7491L18.9417 22.8531L20.3796 19.9923L9.78066 20.8207Z" />
      </svg>
    </div>
    <div style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      position: "absolute",
      inset: "5px 0px 0px 10px",
      backgroundColor: colors.transparent,
      pointerEvents: "none",
      color: colors.greyDarkPrimary,
      ...fonts.paragraph,
      ...fonts.fontSize4
    }}>
      {content}
    </div>
  </div> )
})
// #endregion